import React from 'react';
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import {format} from 'date-fns';

const Wrapper = styled.div`
  flex: 1;
  flex-direction: column;
  overflow: auto;
  display: flex;
  padding: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal()};
`;

const Row = styled(Grid)`
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${({theme}) => theme.black};
  border-right: 1px solid ${({theme}) => theme.black};
  &:first-child {
    border-top: 1px solid ${({theme}) => theme.black};
  }
`;

const Column = styled(Grid.Unit)`
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  border-left: 1px solid ${({theme}) => theme.black};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Text = styled.div`
  text-align: center;
  font-weight: ${({bold}) => (bold ? 'bold' : null)};
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const GraphWrapper = styled(Grid)`
  min-height: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
`;

const GraphItem = styled(Grid.Unit)`
  background: ${({bg}) => bg};
  min-height: 100%;
`;

/*
Many branches which return undefined.
parseFloat(undefined).toFixed(2) => NaN
Handle undefined or return default below the switch.

anchor 0 to 1
value -1 to 1
*/

const calcValue = (index, anchor, value) => {
  switch (index) {
    case 0:
      if (anchor > 0) {
        if (value > 0) return anchor;
        else return anchor + value;
      }
      return 0;
    case 1:
      if (anchor > 0) {
        if (value > 0) return 0;
        else return -value;
      }
      return 0;
    case 2:
      if (anchor < 1) {
        if (value > 0) return value;
        else return 0;
      }
      return 0;
    case 3:
      if (anchor < 1) {
        if (value > 0) return 1 - (anchor + value);
        else return 1 - anchor;
      }
      return 0;
    default:
      break;
  }
};

const calc = (index, anchor, value) => {
  const calculatedValue = calcValue(index, anchor, value);
  if (calculatedValue === 0) return 0.00001;
  return calculatedValue;
};

const Graph = data => {
  return (
    <GraphWrapper>
      <GraphItem size={calc(0, data.item.anchor, data.item.value)} />
      <GraphItem
        bg={calc(1, data.item.anchor, data.item.value) > 0.00001 ? data.item.color : null}
        size={calc(1, data.item.anchor, data.item.value)}
      />
      <GraphItem
        bg={calc(2, data.item.anchor, data.item.value) > 0.00001 ? data.item.color : null}
        size={calc(2, data.item.anchor, data.item.value)}
      />
      <GraphItem size={calc(3, data.item.anchor, data.item.value)} />
    </GraphWrapper>
  );
};

const columnContent = item => {
  if (item)
    switch (item.__typename) {
      case 'TableReportText':
        return <Text bold={item.appearance && item.appearance.bold}>{item.text}</Text>;
      case 'TableReportDate':
        return <Text bold={item.appearance && item.appearance.bold}>{format(item.date, 'DD.MM.YYYY')}</Text>;
      case 'TableReportGraph':
        return <Graph item={item} />;
      default:
        return <div />;
    }
  else return null;
};

const TableGraph = ({data}) => (
  <Wrapper>
    {data.data.map((dItem, dIndex) => (
      <Row key={dIndex}>
        {dItem.map((cItem, cIndex) => (
          <Column key={cIndex} size={1 / dItem.length}>
            {columnContent(cItem)}
          </Column>
        ))}
      </Row>
    ))}
  </Wrapper>
);

export default TableGraph;
